import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import {
  faLinkedin,
  faTwitterSquare,
  faWhatsappSquare,
  faYoutubeSquare,
  faFacebookMessenger,
  faInstagramSquare,
  faFacebookSquare
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fal,
  faLinkedin,
  faTwitterSquare,
  faWhatsappSquare,
  faYoutubeSquare,
  faFacebookMessenger,
  faInstagramSquare,
  faFacebookSquare
);
dom.watch();
